import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';
import axios, { AxiosInstance } from 'axios';
import { BASE_URL, createApiClient } from '../api/client';

interface AuthContextType {
  token: string | null;
  apiClient: AxiosInstance | null;
  login: (token: string) => Promise<boolean>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(() =>
    localStorage.getItem('adminToken'),
  );

  const logout = useCallback(() => {
    setToken(null);
    localStorage.removeItem('adminToken');
  }, []);

  const apiClient = useMemo(() => {
    if (!token) return null;
    return createApiClient(token, logout);
  }, [token, logout]);

  const login = async (t: string): Promise<boolean> => {
    try {
      await axios.post(
        `${BASE_URL}/api/v1/admin/courses/get-list`,
        {},
        { headers: { 'X-Admin-Key': t } },
      );
      setToken(t);
      localStorage.setItem('adminToken', t);
      return true;
    } catch {
      return false;
    }
  };

  return (
    <AuthContext.Provider value={{ token, apiClient, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
